<template>
    <AppMainFormCard :isLoading="isLoading" :tituloTela="tituloTela" :canDelete="isEditing" @delete="beforeDeleteRegistro" @add="novoRegistro" 
        :isSearch="true" @search="goSearch">
        <v-form v-model="isFormValid" ref="form">
            <v-layout row justify-center>
                <v-flex class="item" xs12 md11 ma-5>
                    <h3><b>Dados do Laboratório</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row justify-center="">
                <v-flex class="item" xs8 md8 lg8>
                    <v-text-field :rules="[campoObrigatorio]" v-model.trim="registro.nmLaboratorio" label="Nome" outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs3 md3 lg3>
                    <v-text-field
                        :rules="[campoObrigatorio, tamanhoMaximoTrinta]"
                        v-model.trim="registro.cdItem"
                        label="Código na empresa"
                        outlined
                        clearable
                    ></v-text-field>
                </v-flex>
            </v-layout>
        </v-form>
        <v-layout pa-2 pr-8 pl-8>
            <v-flex>
                <AppMainActionsButtonsForm @save="saveRegistro" @return="voltar" :canDelete="false"/>
            </v-flex>
        </v-layout>
    </AppMainFormCard>
</template>

<script>
import { campoObrigatorio, tamanhoMaximoTrinta } from '@/filters/rules'
import { TituloShouldNavigate,
        MensagemShouldNavigate,
        MensagemSuccessSave } from '@/resourceMessageFile.js'

import AppMainFormCard from '@/components/layout/AppMainFormCard.vue'
import AppMainActionsButtonsForm from '@/components/layout/AppMainActionsButtonsForm.vue'

export default {
    name: 'Laboratorio',
    components: {
        AppMainFormCard,
        AppMainActionsButtonsForm,
    },
    data() {
        return{
            isFormValid: false,
            isEditing: false,
            isModified: false,
            registro: {},
            registroBanco: {},
            isLoading: false,
        }
    },
    computed: {
        tituloTela: {
            get() {
                if (this.isEditing)
                    return 'Laboratório: ' + this.registro.idLaboratorio

                return 'Inserindo novo Laboratório'
            }
        },
    },
    methods: {
        campoObrigatorio,
        tamanhoMaximoTrinta,
        changeViewState(status, value) {
            if (status == 'isInserting'){
                this.isLoading = true
                if (this.$refs.form != undefined) 
                {
                    this.$refs.form.reset()
                }
                this.carregarRegistrosLimpos()
                this.isLoading = false
                this.isEditing = false
                this.isModified = false
            } else if (status == 'isEditing'){
                this.isLoading = true
                this.getRegistro(value)
                this.isEditing = true
            } else if (status == 'isError'){
                this.$store.commit('setSnack', {type: 'error', msg : value})
                this.isLoading = false
            } else if (status == 'endLoading'){
                this.isLoading = false
            } else if (status == 'isLoading'){
                this.isLoading = true
            }
        },
        initViewFromRoute(route) {
            if (route.params.id){
                this.changeViewState('isEditing', route.params.id)
            } else {
                this.changeViewState('isInserting', null)
            }
        },
        getRegistro (id) {
            this.$axios.get('laboratorio/' + id)
            .then((response) => {
                var rec = response.data[0].data
                this.registro = Object.assign({}, rec)
                this.registroBanco = Object.assign({}, rec)
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
                this.$router.push({ path: '/laboratorio'})
            })
        },
        saveRegistro() {
            if (this.$refs.form.validate())
            {
                if (this.isEditing)
                {
                    this.updateRegistro()
                }
                else
                {
                    this.insertRegistro()
                }
            }
        },
        insertRegistro () {
            this.changeViewState('isLoading')
            this.registro.dsLaboratorio = this.registro.dsLaboratorio == null ? '' : this.registro.dsLaboratorio
            this.$axios.post('laboratorio/', this.registro)
            .then((response) => {
                this.$router.replace({ name: 'laboratorio', params: { id: response.data[0].data.idLaboratorio }})
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.changeViewState('endLoading')
                this.$store.dispatch('actLoadLaboratorios')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        updateRegistro() {
            this.changeViewState('isLoading')
            this.registro.dsLaboratorio = this.registro.dsLaboratorio == null ? '' : this.registro.dsLaboratorio
            this.$axios.put('laboratorio/' + this.registro.idLaboratorio, this.registro)
            .then(() => {
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.initViewFromRoute(this.$route)
                this.$store.dispatch('actLoadLaboratorios')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        beforeDeleteRegistro() {
            this.$root.$confirm('Deseja Excluir?', 'O registro será excluído permanentemente.', { color: 'red', width: 400 })
            .then(confirm => {
                if (confirm)
                    this.deleteRegistro()
            })
        },
        deleteRegistro() {
            this.changeViewState('isLoading')
            this.$axios.delete('laboratorio/' + this.registro.idLaboratorio)
            .then(() => {
                this.$router.go(-1)
                this.changeViewState('endLoading')
                this.$store.dispatch('actLoadLaboratorios')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        novoRegistro() {
            this.$router.push({ path: '/laboratorio' })
        },
        carregarRegistrosLimpos() {
            this.registro = {
                idLaboratorio: 0,
                nmLaboratorio: '',
                dsLaboratorio: '',
                cdItem: ''
            }
            this.registroBanco = {
                idLaboratorio: 0,
                nmLaboratorio: '',
                dsLaboratorio: '',
                cdItem: ''
            }
        },
        goSearch() {
            this.$router.push({ path: '/laboratorioSearch' })
        },
        shouldNavigate(to, from, next) {
            if (JSON.stringify(this.registro) !== JSON.stringify(this.registroBanco) && !this.isLoading)
            {
                this.$root.$confirm(TituloShouldNavigate, MensagemShouldNavigate, { color: 'red', width: 400 })
                    .then(confirm => {
                        next(confirm)
                        return confirm
                    })
            }
            else
            {
                next()
                return true
            }
        },
        voltar() {
            this.$router.go(-1)
        }
    },
    watch: {
        '$route' (to) {
            this.initViewFromRoute(to)
        },
    },
    mounted() {
        this.initViewFromRoute(this.$route)
    },
    beforeRouteUpdate(to, from, next){
        this.shouldNavigate(to, from, next)
    },
    beforeRouteLeave (to, from, next) {
        this.shouldNavigate(to, from, next)
    }
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
    .marginTitle {
        margin: 15px;
    }
    .headerCard {
        color: white; 
        background: #04222D; 
        padding:10px;
    }
</style>
